import { render } from "./Home.vue?vue&type=template&id=3a86e9bf&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3a86e9bf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a86e9bf"

export default script